/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { applicability } from './datagrid.interface';
import _ from 'lodash';
import { MatDialogRef } from '@angular/material/dialog';
import { concat, Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';

@Component({
  selector: 'save-filter',
  templateUrl: 'save-filter.component.html',
  styleUrls: ['./datagrid.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SaveFilterComponent implements OnInit {
  applicabilities: Array<applicability> = [
    { key: 'all.text', value: 'EVERYONE' },
    {
      key: 'text.selected_users',
      value: 'USERS',
    },
    {
      key: 'text.selected_teams',
      value: 'TEAMS',
    },
  ];
  filter: any = { filter_applicability: 'EVERYONE' };
  listValue$: Observable<any[]> = new Observable<any[]>();
  preloadedValue: any = [];
  valueSubject$: Subject<string | null> = new Subject<string | null>();
  fieldDetails: any = {
    USERS: {
      url: '/user/all',
      dataKey: 'user_uid',
      displayFormat: '{{first_name}} {{last_name}}',
      bindValue: 'user_uid',
    },
    TEAMS: {
      url: '/teams/summary',
      dataKey: 'team_uid',
      displayFormat: '{{team_name}}',
      bindValue: 'team_uid',
    },
  };
  lookupLoading: boolean = false;
  selectedApplicability: any = 'EVERYONE';
  pageSize: number = 1;
  searchTerm: string = '';
  cancelFilter: boolean = false;

  constructor(
    private _dataCollectorService: DataCollectorService,
    public dialogRef: MatDialogRef<SaveFilterComponent>
  ) {
    dialogRef.disableClose = true;
  }
  ngOnInit(): void {}
  onSelectionChange(event): void {
    this.pageSize = 1;
    this.filter.value = '';
    this.selectedApplicability = event.value;
    this.preloadedValue = [];
    this.setPreLoadedValueToLookUp();
  }

  setPreLoadedValueToLookUp(): any {
    const fieldObject = this.fieldDetails[this.selectedApplicability];
    const fieldValueURL = fieldObject?.url;
    const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;
    const paramObj = {
      'page': this.pageSize,
      'filter.keyword': this.searchTerm,
    };
    return this._dataCollectorService
      .getData(dataUrl, paramObj)
      .subscribe((response: any) => {
        this.preloadedValue = this.preloadedValue.length
          ? [
              ...this.preloadedValue,
              ...this.constructLookupList(fieldObject, response.data),
            ]
          : this.constructLookupList(fieldObject, response.data);
        this.lookupLoading = false;
        this.loadLookupValues();
      });
  }

  setListValue(term = ''): any {
    if([null,undefined].includes(term)){
      this.lookupLoading = false;
      return of(null);
    }
    const fieldObject = this.fieldDetails[this.selectedApplicability];
    const fieldValueURL = fieldObject?.url;
    const dataUrl = `${this._dataCollectorService.baseurl()}${fieldValueURL}`;
    const paramObj = {
      'page': this.pageSize,
      'filter.keyword': term,
    };
    return this._dataCollectorService.getData(dataUrl, paramObj).pipe(
      map((response: any) => {
        this.searchTerm = term;
        this.preloadedValue = this.constructLookupList(
          fieldObject,
          response.data
        );
        return this.constructLookupList(fieldObject, response.data);
      })
    );
  }

  appendValueToItems(): void {
    this.pageSize = this.pageSize + 1;
    this.lookupLoading = true;
    this.setPreLoadedValueToLookUp();
  }

  constructLookupList(fieldObject, data): any {
    const template = _.template(fieldObject.displayFormat);
    const list = data.map((key) => {
      key.displayValue = template(key);
      return key;
    });
    return list;
  }

  getLookupValueKey(): string {
    return this.fieldDetails[this.selectedApplicability].bindValue;
  }

  closeDialog(saveFilterForm): void {
    this.filter = { ...this.filter, cancel: this.cancelFilter };
    if (saveFilterForm.valid && !this.cancelFilter) {
      this.dialogRef.close(this.filter);
    }
  }

  closeDialogOnCancel(): void {
    this.cancelFilter = true;
    this.filter = { ...this.filter, cancel: this.cancelFilter };
    this.dialogRef.close(this.filter);
  }

  get fieldValuePlaceholder(): string {
    return this.filter.filter_applicability === 'USERS'
      ? 'text.select_users'
      : 'text.select_teams';
  }

  get fieldValueErrorMessage(): string {
    return this.filter.filter_applicability === 'USERS'
      ? 'text.choose_user.atleast_one'
      : 'text.choose_team.atleast_one';
  }

  get getFieldValueLabel(): string {
    return this.filter.filter_applicability === 'USERS'
      ? 'saveFilter.filter_uservalue_label'
      : 'saveFilter.filter_teamvalue_label';
  }

  private loadLookupValues(): any {
    this.lookupLoading = false;
    this.listValue$ = concat(
      of(this.preloadedValue),
      this.valueSubject$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => (this.lookupLoading = true)),
        tap(() => (this.pageSize = 1)),
        switchMap((term: any) =>
          this.setListValue(term).pipe(
            catchError(() => of(this.preloadedValue)),
            tap(() => (this.lookupLoading = false))
          )
        )
      )
    );
  }
}
